import CryptoJS from 'crypto-js';
import { JSEncrypt } from 'jsencrypt';
import forge from 'node-forge';

export class Encryptor {
  pubKey: string;

  constructor(key: string) {
    this.pubKey = key;
  }

  /**
   * @param value
   * @returns {string|*|WordArray}
   */
  encryptForRSA(value = '') {
    const publicKey = forge.pki.publicKeyFromPem(this.pubKey);
		const encrypted = publicKey.encrypt(value, 'RSA-OAEP', { md: forge.md.sha256.create() });
		
    return forge.util.encode64(encrypted);
  }

  decryptForRSA(encryptedValue = '', privKey: string) {
    const privateKey = forge.pki.privateKeyFromPem(privKey);
    const decrypted = privateKey.decrypt(forge.util.decode64(encryptedValue), 'RSA-OAEP');
    return decrypted;
  }

  // encryptForRSA(value = '') {
  //   const encrypt = new JSEncrypt()
  //   encrypt.setPublicKey(this.pubKey)
  //   const encrypted = encrypt.encrypt(value)
  //   return encrypted
  // }
  /**
   * @param encrypted
   * @returns {string|*|WordArray}
   */
  // decryptForRSA(encrypted: string, privateKey: string) {
  //   const decrypt = new JSEncrypt();
  //   decrypt.setPrivateKey(privateKey);
  //   return decrypt.decrypt(encrypted);
  // }

  /**
   * 动态生成16位的key值 用于AES加密
   * */
  getRandomStr(length: number) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const n = length || 32;
    // Clave AES generada con CSPRNG (Web Crypto), NO con Math.random (predecible).
    // Mantiene el mismo formato (string del charset) → compatible con el gateway.
    // Si Web Crypto no está disponible, FALLA (no caemos a Math.random: sería inseguro).
    const webCrypto = (globalThis as any)?.crypto ?? (typeof window !== 'undefined' ? (window as any).crypto : undefined);
    if (!webCrypto?.getRandomValues) {
      throw new Error('Web Crypto (crypto.getRandomValues) no disponible: no se puede generar clave segura');
    }
    const rnd = new Uint32Array(n);
    webCrypto.getRandomValues(rnd);
    let noceStr = '';
    for (let i = 0; i < n; i++) noceStr += chars.charAt(rnd[i] % chars.length);

    return noceStr;
  }

  AESEncryption(keystr: string, parmasStr: string) {
    const key = CryptoJS.enc.Utf8.parse(keystr);
    const encrypted = CryptoJS.AES.encrypt(parmasStr, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString();
  }

  AESDecrypt(keystrs: string, parmasStr: string) {
    const keystr = CryptoJS.enc.Utf8.parse(keystrs);
    const encryptedHexStr = CryptoJS.enc.Hex.parse(parmasStr);
    const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, keystr, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return decryptedData.toString(CryptoJS.enc.Utf8);
  }
}
